module.exports = __webpack_public_path__ + "img/pubmed-logo-blue.87456274.jpg";